<template>
<div>
	<b-navbar class="submenu">
		<b-container>
			<b-navbar-brand href="#">Customer Uploads</b-navbar-brand>
			<b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
			<b-collapse id="nav-collapse" is-nav>
				<b-navbar-nav>
				
				</b-navbar-nav>
			</b-collapse>
		</b-container>
	</b-navbar>
	<div id="content">
		<b-overlay :show="this.working" rounded="sm">
			<div class="row">
				<div class="col-md-12">
					
					Showing {{ documents.length }} recent Document(s)
					<b-table :filter="search" striped hover small :items="documents" :fields="[{label: 'Added', key:'createDateTime', sortable:true}, {label: 'Customer', key:'email', sortable:false}, {label: 'Processed', key:'processedDateTime', sortable:false}, {label: 'Doc', key:'url', sortable:false}, {label: 'Details', key:'showDetails', sortable:false}]" selectable select-mode="single">
					
						<template #cell(url)="data">
							<a :href="data.value" target="_blank"><b-icon icon="folder2-open"/></a>
						</template>
						<template #cell(showDetails)="row">
							<b-button size="sm" variant="link" @click="row.toggleDetails" class="mr-2">
								<b-icon icon="three-dots" />
							</b-button>
						</template>

						<template #row-details="row">
							<b-card>
								<b-row>
									<b-col md="5">
										<img width="100%" :src="row.item.url" />
									</b-col>
									<b-col md="7">
										<p>Document:</p>
										<code style="max-width: 600px; display:block">
											{{ JSON.stringify(row.item) }}
										</code>
									</b-col>
								</b-row>
							</b-card>
						</template>

					</b-table>					
					
				</div>
			</div>
		</b-overlay>
	</div>
</div>
</template>
<script>
export default {
  name: 'Stats',
  data() {
	return{
		customers: null,
		documents: null,
		selfId: null,
		working: true
	}
  },
  methods: {
	getCustomers: function(){
		this.working = true;
		this.$http.get(this.$config.ApiUri + "/Customers")
			.then((result) => {
				this.customers = result.data;
				for (var x = 0; x< this.customers.length; x++)
				{
					this.customers[x].customers = this.customers[x].person.firstName 
						+ " " + this.customers[x].person.lastName
					this.customers[x].linked = this.customers[x].employerID != null;
					this.working = false;
				}
				this.getCustomerUploads();
			}
		)
	},
	retry: function(id, flatObject = null){
		this.working = true;
		this.$http.post(this.$config.ApiUri + "/Documents/" + id + "/RetryRequests" + (flatObject ? ("?flatObject=" + btoa(flatObject)) : ""))
			.then(() => {
				this.getCustomerUploads();
			}
		);
	},
	getCustomerUploads: function(){
		this.working = true;
		this.$http.get(this.$config.ApiUri + "/Documents")
			.then((result) => {
				this.documents = result.data;
				for(var d = 0; d < this.documents.length; d++){
					this.documents[d].showDetails = true;
					if (this.documents[d].createDateTime) { this.documents[d].createDateTime = this.documents[d].createDateTime.replace("T", " ").split('.')[0]; }
					if (this.documents[d].processedDateTime) { this.documents[d].processedDateTime = this.documents[d].processedDateTime.replace("T", " ").split('.')[0].split(' ')[1]; }
					if (this.documents[d].hubItemCreatedDate) { this.documents[d].hubItemCreatedDate = this.documents[d].hubItemCreatedDate.replace("T", " ").split('.')[0].split(' ')[1]; }
					for(var c = 0; c < this.customers.length; c++) {
						if (this.customers[c].id == this.documents[d].customerId) {
							this.documents[d].email = this.customers[c].person.email;
						}
					}
				}
				this.working = false;
			}
		)
	},
	getSelf: function() {
		this.$http.get(this.$config.ApiUri + "/Customers/00000000-0000-0000-0000-000000000000")
			.then((result) => {
				this.selfId = result.data.id;
			}
		)
	},
	onLoad() {
		this.getSelf();
		this.getCustomers();
	},
	
  },
  mounted: function() { this.onLoad(); }
}
</script>